import { useGetTreatment } from '@zg-rentals/split';

import SplitTestConstants from '../constants/SplitTestConstants';

import type { SplitExperimentsProps } from '@zg-rentals/split';

export const useAIListingCreation = () => {
  const { data: splitExperiment, isLoading } = useGetTreatment({
    featureName: SplitTestConstants.ZRM_AI_LISTING_CREATION,
  });

  const splitExperiments: SplitExperimentsProps = splitExperiment
    ? { [SplitTestConstants.ZRM_AI_LISTING_CREATION]: splitExperiment }
    : {};

  return { splitExperiments, isLoading };
};
